import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { User } from 'src/app/models';
import { AuthService } from 'src/app/services/auth.service';
import { MasterApiService } from 'src/app/services/master-api.service';

@Component({
    selector: 'app-user-settings',
    templateUrl: './user-settings.component.html',
    styleUrls: ['./user-settings.component.sass'],
    standalone: false
})
export class UserSettingsComponent {

  user: User | null;
  group: FormGroup;

  constructor(private api: MasterApiService, private auth: AuthService, private fb: FormBuilder) {
    this.user = null;
    this.api.resources.auth.users.get(this.auth.userValue!.userName!).subscribe(user => this.user = user);
    this.group = this.fb.group({
      userName: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  async save() {
    const data = this.group.value;
    await this.updateUser(data);
  }

  async updateUser(data: User) {
    this.user = await firstValueFrom(this.api.resources.auth.users.put(data));
    // Refrescar usuari a this.auth ?
  }
}
